import InfoIcon from "../../assets/icons/info.svg";
import PropTypes from "prop-types";
import Cancel from "../../assets/icons/cancel.svg";
import { useDispatch } from "react-redux";
import { closeAlert } from "../../store/alert/alert";

function Alert({ alert }) {
  const dispatch = useDispatch();
  const closeAlertHandler = () => {
    dispatch(closeAlert());
  };
  return (
    <div id="alert">
      <div
        className={`${
          alert.view === true ? "show" : "hide"
        } fixed top-0 w-full z-50 p-6 capitalize`}
      >
        <div className={`${alert.type === "error" ? "bg-red-500" : ""} ${alert.type === "warning" ? "bg-yellow-400" : ""} ${alert.type === "success" ? "bg-green-500" : ""} flex justify-between p-6 text-white items-start`}>
          <div className="flex items-start">
            <img className="mr-3" src={InfoIcon} alt="" />
            <div className="text">
              <div className="title font-bold">{alert.title}</div>
              <p className="caption font-semibold">{alert.caption}</p>
            </div>
          </div>
          <div onClick={closeAlertHandler}>
            <img src={Cancel} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

Alert.propTypes = {
  alert: PropTypes.object.isRequired,
};

export default Alert;
